import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_SALE_CREDIT_NOTE, READ_SALE_INVOICE } from '../../../constants/eInvoicePermissions';
import { SALES_MODULE_KEY } from '../../settings/constants/roleModules';

export default function SalesDocumentsAccessLayout() {
  const title = useRoleModuleLabel(SALES_MODULE_KEY);

  return <EInvoiceAccessLayout permissions={[READ_SALE_INVOICE, READ_SALE_CREDIT_NOTE]} title={title} />;
}
